import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface VerifySubscriptionParams {
  sessionId: string;
  userEmail?: string;
  userId?: string;
}

export interface VerifySubscriptionResponse {
  success: boolean;
  newUserCreated?: boolean;
  userEmail?: string;
  /** Single-use magic-link token for a just-created account; exchange with verifyOtp. */
  tokenHash?: string;
  message?: string;
}

export const useVerifySubscription = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: VerifySubscriptionParams) => {
      const { data, error } = await supabase.functions.invoke("stripe-handler", {
        body: {
          action: "verifyAndSyncSubscription",
          sessionId: params.sessionId,
          userEmail: params.userEmail,
          userId: params.userId,
        },
      });

      if (error) throw error;
      return data as VerifySubscriptionResponse;
    },
    onSuccess: (data, params) => {
      queryClient.invalidateQueries({ queryKey: ["subscription"] });
      queryClient.invalidateQueries({ queryKey: ["users-with-subscriptions"] });

      console.log("Subscription verified and synced");
    },
    onError: (error: Error) => {
      console.error("Subscription verification error:", error);
    },
  });

  return {
    verifySubscription: (params: VerifySubscriptionParams) => mutation.mutateAsync(params),
    isVerifying: mutation.isPending,
    error: mutation.error,
  };
};
